import * as Routing from 'react-router-dom';
export default Routing;
export const Router = Routing.HashRouter;
export const {Link, Route, Redirect} = Routing;